import React from 'react';

const NotFoundPage = () => {
	return (
		<section>
			<div className="wrapper" style={{ textAlign: "center" }}>
				<h2>Something went wrong.</h2>

				<p>Sorry, but the page you&rsquo;re looking for <span className="no-wrap">can&rsquo;t be found.</span></p>
			</div>
		</section>
	);
};

export default NotFoundPage;